function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SidebarTreeBusinessTerms',
  props: {
    terms: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      tree: [],
      filter: '',
      IMG_DOMAIN: 'mdi-file-tree',
      IMG_SUBDOMAIN: 'mdi-family-tree',
      IMG_TERM: 'mdi-book-open-blank-variant',
      SHARED_NAME: 'SHARED',
      items: [],
      search: null
    };
  },
  created: function created() {
    // this.getTree()
    this.getItems();
  },
  computed: {
    filteredTree: function filteredTree() {
      var filteredTree = [];
      var filterLowerCase = this.filter.toLowerCase();
      for (var i = 0; i < this.tree.length; i++) {
        var term = this.tree[i];
        if (term.domain.toLowerCase().includes(filterLowerCase)) {
          filteredTree.push(term);
        } else {
          var dcontains = term.dcontains;
          for (var j = 0; j < dcontains.length; j++) {
            var dcontain = dcontains[j];
            if (dcontain.subdomain.toLowerCase().includes(filterLowerCase)) {
              filteredTree.push(term);
            } else {
              var b_terms = dcontain.scontains;
              for (var k = 0; k < b_terms.length; k++) {
                var b_term = b_terms[k];
                if (b_term.business_term.toLowerCase().includes(filterLowerCase)) {
                  filteredTree.push(term);
                }
              }
            }
          }
        }
      }
      return filteredTree;
    }
  },
  methods: {
    getTree: function getTree() {
      var _this = this;
      this.tree = [];
      this.terms.forEach(function (term) {
        var indexDomainTree = _this.tree.findIndex(function (item) {
          return item.domain === term.domain;
        });
        var termTree = {
          business_term: term.business_term,
          kbusiness_term: term.kbusiness_term,
          rcontains: term.relationship.contains,
          nivel: 1,
          img: _this.IMG_TERM
        };
        if (indexDomainTree === -1) {
          _this.tree.push({
            domain: term.domain,
            dcontains: [{
              subdomain: term.subdomain,
              scontains: [termTree],
              img: _this.IMG_SUBDOMAIN
            }],
            img: _this.IMG_DOMAIN
          });
        } else {
          var indexSubdomainTree = _this.tree[indexDomainTree].dcontains.findIndex(function (item) {
            return item.subdomain === term.subdomain;
          });
          if (indexSubdomainTree === -1) {
            _this.tree[indexDomainTree].dcontains.push({
              subdomain: term.subdomain,
              scontains: [],
              img: _this.IMG_SUBDOMAIN
            });
            indexSubdomainTree = _this.tree[indexDomainTree].dcontains.findIndex(function (item) {
              return item.subdomain === term.subdomain;
            });
          }
          _this.tree[indexDomainTree].dcontains[indexSubdomainTree].scontains.push(termTree);
        }
      });
      // Add Shared Terms
      var sharedTerms = this.terms.filter(function (term) {
        return term.shared === true;
      }).map(function (term) {
        term['img'] = _this.IMG_TERM;
        return term;
      });
      this.tree.push({
        domain: this.SHARED_NAME,
        dcontains: [{
          subdomain: this.SHARED_NAME,
          scontains: sharedTerms,
          img: this.IMG_SUBDOMAIN
        }],
        img: this.IMG_DOMAIN
      });
    },
    getItems: function getItems() {
      var _this2 = this;
      this.items = [];
      this.terms.forEach(function (term) {
        var indexDomainTree = _this2.items.findIndex(function (item) {
          return item.name === term.domain;
        });
        var termTree = _objectSpread(_objectSpread({
          id: term.kbusiness_term,
          name: term.business_term
        }, term), {}, {
          icon: _this2.IMG_TERM,
          link: true
        });
        if (indexDomainTree === -1) {
          _this2.items.push({
            id: term.kdomain,
            name: term.domain,
            children: [{
              id: term.ksubdomain,
              name: term.subdomain,
              children: [termTree],
              icon: _this2.IMG_SUBDOMAIN
            }],
            icon: _this2.IMG_DOMAIN
          });
        } else {
          var indexSubdomainTree = _this2.items[indexDomainTree].children.findIndex(function (item) {
            return item.name === term.subdomain;
          });
          if (indexSubdomainTree === -1) {
            _this2.items[indexDomainTree].children.push({
              id: term.ksubdomain,
              name: term.subdomain,
              children: [],
              icon: _this2.IMG_SUBDOMAIN
            });
            indexSubdomainTree = _this2.items[indexDomainTree].children.findIndex(function (item) {
              return item.name === term.subdomain;
            });
          }
          _this2.items[indexDomainTree].children[indexSubdomainTree].children.push(termTree);
        }
      });

      // Add shared terms
      var sharedTerms = this.terms.filter(function (term) {
        return term.shared === true;
      }).map(function (term) {
        term['id'] = term.kbusiness_term;
        term['name'] = term.business_term;
        term['icon'] = _this2.IMG_TERM;
        term['link'] = true;
        return term;
      });
      this.items.push({
        id: this.SHARED_NAME,
        name: this.SHARED_NAME,
        children: [{
          id: "".concat(this.SHARED_NAME, "-subdomain"),
          name: this.SHARED_NAME,
          children: sharedTerms,
          icon: this.IMG_SUBDOMAIN
        }],
        icon: this.IMG_DOMAIN
      });
    },
    onClose: function onClose() {
      this.$emit('onClose');
    }
  }
};